import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { getVkAuthUrl, getYandexAuthUrl } from '../../services/authService';
import './AuthForms.css';

interface LoginFormProps {
  onToggleForm: () => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ onToggleForm }) => {
  const { login, error, isLoading, clearError } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [formError, setFormError] = useState<string | null>(null);

  // Обработчик для отправки формы
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    clearError();
    setFormError(null);

    // Простая валидация
    if (!email || !password) {
      setFormError('Пожалуйста, заполните все поля');
      return;
    }

    try {
      await login(email, password);
    } catch (err) {
      // Ошибка обрабатывается в контексте Auth
    }
  };

  return (
    <div className="auth-form-container">
      <h2>Вход</h2>
      
      {/* Форма входа */}
      <form className="auth-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Введите email"
            disabled={isLoading}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="password">Пароль</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Введите пароль"
            disabled={isLoading}
          />
        </div>
        
        {/* Отображение ошибок */}
        {(error || formError) && (
          <div className="auth-error">
            {formError || error}
          </div>
        )}
        
        <button
          type="submit"
          className="auth-button"
          disabled={isLoading}
        >
          {isLoading ? 'Вход...' : 'Войти'}
        </button>
      </form>
      
      {/* Социальные сети для входа */}
      <div className="social-login">
        <p>Или войдите через:</p>
        <div className="social-buttons">
          <a href={getVkAuthUrl()} className="social-button vk">
            ВКонтакте
          </a>
          <a href={getYandexAuthUrl()} className="social-button yandex">
            Яндекс
          </a>
        </div>
      </div>
      
      {/* Переключение на регистрацию */}
      <div className="auth-toggle">
        <span>Нет аккаунта?</span>
        <button
          className="toggle-button"
          onClick={onToggleForm}
          type="button"
        >
          Зарегистрироваться
        </button>
      </div>
    </div>
  );
};

export default LoginForm; 